import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        headerFields: [
            {
                name: "patientName",
                label: "Név",
                visibility: true,
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "TAJ",
                visibility: true,
            },
            {
                name: "patientPlaceOfBirth",
                label: "Születési hely",
                visibility: true,
            },
            {
                name: "patientDateOfBirth",
                label: "Születési idő",
                visibility: true,
                slot_name: "birthdate_format",
            },
            {
                name: "patientTechnicalId",
                label: "Technikai azonosító",
                visibility: true,
            },
            {
                name: "siteName",
                label: "Ellátóhely ",
                visibility: true,
            },
            {
                name: "sendCode",
                label: "Beküldő kód",
                visibility: true,
            },
            {
                name: "doctorName",
                label: "Orvos",
                visibility: true,
            },
            {
                name: "packageName",
                label: "Csomag",
                visibility: true,
            },
            {
                name: "labGroupName",
                label: "Vizsgálat",
                visibility: true,
            },
            {
                name: "labTypeName",
                label: "Vizsgálat típusa",
                visibility: true,
            },
            {
                name: "sampleTypeName",
                label: "Mintatípus",
                visibility: true,
            },
            {
                name: "synlabType",
                label: "Medicare",
                visibility: true,
            },
            {
                name: "hl7",
                label: "HL7",
                visibility: true,
            },
            {
                name: "barcodeNumber",
                label: "Vonalkód szám",
                visibility: true,
            },
            {
                name: "quantity",
                label: "Minta darabszám",
                visibility: true,
            },
            {
                name: "samplingDate",
                label: "Mintavétel ideje",
                visibility: true,
                slot_name: "startdate_format",
            },
            {
                name: "labStatus",
                label: "Állapot",
                visibility: true,
            },
            {
                name: "invoiceNumber",
                label: "Számlaszám",
                visibility: true,
            },
            {
                name: "resultDate",
                label: "Eredmény megérkezésének ideje",
                visibility: true,
                slot_name: "resultdate_format",
            },
            {
                name: "richter",
                label: "Richter",
                visibility: true,
            },
            {
                name: "richterReferralId",
                label: "Richter beutaló",
                visibility: true,
            },
        ],
        searchHeaderFields: [
            {
                name: "patientName",
                label: "Név",
                formSize: 4,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "TAJ",
                formSize: 4,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "patientPlaceOfBirth",
                label: "Születési hely",
                formSize: 4,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "patientDateOfBirth",
                label: "Születési idő",
                formSize: 4,
                formType: "date",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "patientTechnicalId",
                label: "Technikai azonosító",
                formSize: 4,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "siteIds",
                label: "Ellátóhely ",
                formSize: 4,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllActiveCompanySite,
                    formatOption: function (val) {
                        return val.siteName;
                    },
                    formatText: function (val) {
                        return val.siteName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'siteName',
                    returnValue: 'id',
                    enableSelectAll: true,
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "sendCode",
                label: "Beküldő kód",
                formSize: 4,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "doctorName",
                label: "Orvos",
                formSize: 4,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "packageName",
                label: "Csomag",
                formSize: 3,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "labGroupName",
                label: "Vizsgálat",
                formSize: 3,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "labTypeName",
                label: "Vizsgálat típusa",
                formSize: 3,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "sampleTypeName",
                label: "Mintatípus",
                formSize: 3,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "barcodeNumber",
                label: "Vonalkód szám",
                formSize: 3,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "quantity",
                label: "Minta darabszám",
                formSize: 3,
                formType: "number",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "samplingDateFrom",
                label: "Mintavétel idejétől",
                formSize: 3,
                formType: "date",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "samplingDateTo",
                label: "Mintavétel idejéig",
                formSize: 3,
                formType: "date",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "labStatus",
                label: "Állapot",
                formSize: 3,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "invoiceNumber",
                label: "Számlaszám",
                formSize: 3,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "resultDateFrom",
                label: "Eredmény megérkezésének idejétől",
                formSize: 3,
                formType: "date",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "resultDateTo",
                label: "Eredmény megérkezésének idejéig",
                formSize: 3,
                formType: "date",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "richterReferralId",
                label: "Richter beutaló",
                formSize: 3,
                formType: "text",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "richter",
                label: "Richter",
                formSize: 3,
                formType: "checkbox",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "synlabType",
                label: "Medicare",
                formSize: 3,
                formType: "checkbox",
                formRequired: false,
                formVisible: true,
            },
            {
                name: "hl7",
                label: "HL7",
                formSize: 3,
                formType: "checkbox",
                formRequired: false,
                formVisible: true,
            },

        ]
    }
}
